import { render, staticRenderFns } from "./ProductLicenseTemplateEdit.vue?vue&type=template&id=98af9d04&"
import script from "./ProductLicenseTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./ProductLicenseTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./ProductLicenseTemplateEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports